import styled, { css } from 'styled-components';

export const StyledValue = styled.p(
    ({ theme: { fontSizes, fontWeight, letterSpacing } }) => css`
        display: flex;
        align-items: center;
        font-weight: ${fontWeight.medium};
        font-size: ${fontSizes.f16};
        line-height: 28px;
        letter-spacing: ${letterSpacing.s};
    `,
);

export const ArrowWrapper = styled.div<{ isRotate?: boolean }>(
    ({ isRotate }) => css`
        position: absolute;
        right: 23px;
        transform: ${isRotate ? 'rotate(180deg)' : 'rotate(0deg)'};
    `,
);
